import { Box, Tooltip } from "@mui/material";
import EmailVerificationStatus from "./EmailVerificationStatus";
import Flex from "./Flex";
import RenderWithTooltip from "./RenderWithTooltip";
import Text from "./Text";

const CURRENT_EMAIL_TOOLTIP = "Current sign-in email";
const PENDING_EMAIL_TOOLTIP =
  "New email — pending verification. Sign in with the current email until it is verified.";

const ELLIPSIS_ROW_SX = {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  minWidth: 0,
} as const;

export interface UserEmailCellProps {
  email?: string;
  temporaryEmail?: string;
  isVerified?: boolean;
}

const UserEmailCell = ({
  email,
  temporaryEmail,
  isVerified,
}: UserEmailCellProps) => {
  if (!email) return <Text>-</Text>;

  if (!temporaryEmail) {
    return (
      <Flex alignItems={"center"} gap={"4px"} minWidth={0} width={"100%"}>
        <EmailVerificationStatus isVerified={isVerified} />
        <RenderWithTooltip value={email} />
      </Flex>
    );
  }

  return (
    <Box width={"100%"} minWidth={0}>
      <Tooltip title={CURRENT_EMAIL_TOOLTIP} placement="top" arrow>
        <Flex alignItems={"center"} gap={"4px"} minWidth={0}>
          <EmailVerificationStatus isVerified />
          <Text isTabletext sx={ELLIPSIS_ROW_SX}>
            {email}
          </Text>
        </Flex>
      </Tooltip>

      <Tooltip title={PENDING_EMAIL_TOOLTIP} placement="bottom" arrow>
        <Flex alignItems={"center"} gap={"4px"} minWidth={0}>
          <EmailVerificationStatus isVerified={false} />
          <Text isTabletext variant="subtitle2" sx={ELLIPSIS_ROW_SX}>
            {temporaryEmail}
          </Text>
        </Flex>
      </Tooltip>
    </Box>
  );
};

export default UserEmailCell;
